package com.writerslab

val RuStrings = Strings(
    aiNoCredits = "Кредиты закончились",
    aiPricing = { charsPerCredit -> "1 кредит за ${charsPerCredit / 1000}K символов" },
    aiPreviewWhatYouGet = "Что вы получите",
    aiPreviewTimeHint = "Анализ занимает около 3 минут",
    aiPreviewReviewDesc = "Развёрнутая аналитическая рецензия на 1500–2000 слов: разбор центрального конфликта, ведущих тем, общего впечатления от текста.",
    aiPreviewReviewSample = "Чтобы увидеть свою книгу со стороны: какое ядро в ней прорастает, что цепляет, что не выстреливает, какое ощущение остаётся у читателя после последней страницы.",
    aiPreviewStrengthsDesc = "Сильные и слабые стороны книги: что работает и что стоит доработать — глазами рецензента и бета-ридера.",
    aiPreviewStrengthsSample = "Например: приёмы, которые держат внимание, и места, где текст проседает.",
    aiPreviewCharactersDesc = "Профили всех ключевых героев: функция в сюжете, мотивация, эмоциональная арка, сильные стороны и пробелы в развитии.",
    aiPreviewCharactersSample = "Чтобы увидеть, кто из персонажей по-настоящему работает на историю, а кто остаётся фоном — и где нужно больше движения, чтобы фигура ожила.",
    aiPreviewPlotDesc = "Оценка сюжета и структуры: зачин, ориентация, темп, напряжение, концовка. Что работает в плоте, где провисает, что бьёт зря, что не дотягивает.",
    aiPreviewPlotSample = "Чтобы увидеть структурный скелет книги: какие сцены тянут историю вперёд, какие топчутся на месте.",
    aiPreviewRecommendationsDesc = "Список конкретных правок: что сократить, что переставить, какие сцены доработать, где усилить голос, где поднять ставки — всё с привязкой к главам.",
    aiPreviewRecommendationsSample = "Чтобы было понятно, с чего начинать редактуру и в каком порядке двигаться, а не теряться перед всей рукописью сразу.",
    aiPreviewUnresolvedDesc = "Перечень открытых сюжетных линий, оборванных мотивов, ружей, оставшихся без выстрела, и героев, исчезнувших по дороге.",
    aiPreviewUnresolvedSample = "Чтобы найти линии, которые задуманы, но не сведены, — и решить осознанно: достроить их или вычеркнуть.",
    aiRerun = { a1: Int -> "Перезапустить за $a1" },
    aiScore = "Сводная оценка",
    aiTitle = "Глубокий анализ",
    aiStatusIdle = "Не запущен",
    aiStatusRunning = "Анализирую…",
    aiStatusDone = "Готово",
    aiStatusError = "Ошибка",
    aiReportLoadFailed = "Не удалось загрузить готовый AI-отчёт — он сохранён и никуда не делся. " +
        "Обновите страницу через минуту, повторно запускать анализ не нужно.",
    aiScoringQuestions = mapOf(
        // Сюжет
        "plot_inciting_event" to "В одной из глав первой трети книги происходит событие, без которого основной сюжет не начался бы?",
        "plot_climax_exists" to "Есть ли в книге глава, в которой происходит главное столкновение или окончательное решение основного конфликта?",
        "plot_ending_follows" to "То, чем заканчивается книга, является следствием поступков персонажей в предыдущих главах?",
        "plot_clear_structure" to "Книгу можно разделить на четыре части: знакомство с ситуацией, развитие конфликта, главное столкновение, развязка?",
        "plot_no_long_sag" to "В книге нет провисающих участков — каждые две и более подряд глав двигают основной сюжет?",
        "plot_tension_growing" to "События в последней трети книги — более насыщенные по ставкам, эмоциональному накалу или последствиям — чем события в первой трети?",
        "plot_central_conflict_clear" to "В первой трети книги понятно, кто (или что) с кем (или с чем) борется в основном конфликте?",
        "plot_stakes_clear" to "В первой трети книги понятно, что главный герой может потерять или получить в результате конфликта?",
        "plot_stakes_grow" to "По ходу книги то, чем герой рискует, или то, к чему он стремится, увеличивается — появляются новые угрозы или возможности, либо растёт их масштаб?",
        "plot_events_causal" to "Важные события в книге подготовлены — их причины описаны в предыдущих главах, без совпадений и внезапных внешних сил?",
        "plot_actions_have_consequences" to "В книге не меньше двух раз случается так, что поступок главного героя в одной главе становится причиной события в более поздней главе?",
        "plot_beyond_template" to "В книге есть сюжетный ход или поворот, который не является типовым для данного жанра?",
        "plot_has_ambiguity" to "В книге есть событие, которое можно понять как минимум двумя разными способами?",
        // Персонажи
        "chars_actions_match_description" to "Поступки главного героя соответствуют его описанному характеру (или несоответствия объяснены сюжетом)?",
        "chars_atypical_explained" to "Необычные поступки персонажей объясняются в той же или соседней главе?",
        "chars_internal_conflict" to "Главный герой по ходу книги переходит между противоположными внутренними состояниями (например, вера и сомнение, любовь и ненависть, решимость и страх)?",
        "chars_varied_reactions" to "Главный герой в разных ситуациях реагирует не одинаково — он проявляет как минимум три разные эмоции?",
        "chars_motives_clear" to "Понятно, чего главный герой хочет добиться, — это можно сформулировать одним предложением?",
        "chars_motives_acted_out" to "Главное желание героя подтверждается его поступками — он совершает не менее трёх действий, направленных на достижение этой цели?",
        "chars_main_distinct" to "Главные персонажи различимы по решениям — нельзя поменять местами их поступки в сценах без потери смысла?",
        "chars_secondary_distinct" to "Второстепенные персонажи имеют отличимое действие или реплику — не появляются только как фон?",
        "chars_protagonist_changes" to "Главный герой в конце книги отличается от себя в начале — изменились его взгляды, отношения или цели?",
        "chars_change_prepared" to "Изменение главного героя подготовлено — между его состоянием в начале и в конце есть конкретное событие в одной из глав, после которого он начал меняться?",
        "chars_protagonist_has_flaw" to "У главного героя есть реальная слабость характера — а не черта, которую книга подаёт как достоинство или причину побед?",
        "chars_choice_against_self_interest" to "Герой хотя бы раз принимает решение, после которого его собственное положение становится явно хуже и остаётся таким до конца, — это настоящая потеря, а не выгодный обмен ради чего-то большего?",
        "chars_secondary_has_own_goal" to "Хотя бы один второстепенный персонаж совершает поступки, объяснимые его собственными интересами или прошлым, а не его ролью при главном герое, — у него есть своя линия в нескольких главах?",
        "chars_growth_costs" to "Изменение главного героя по ходу книги сопровождается потерями (отношений, убеждений, способностей, мечт), а не сводится только к чистым приобретениям без сожаления?",
        "chars_inner_life_revealed" to "У главного героя показан внутренний мир — его мысли, сомнения и переживания, а не только внешние поступки?",
        "chars_backstory_shapes" to "У главного героя есть предыстория или прошлый опыт, который объясняет, какой он и почему так поступает?",
        "chars_antagonist_dimensional" to "У антагониста (или главной противостоящей силы) есть собственная понятная мотивация, а не только роль воплощения зла?",
        "chars_motivation_rooted" to "Желания и цели главного героя вытекают из его характера, ценностей или прошлого, а не просто заявлены ради сюжета?",
        "chars_evokes_investment" to "Главный герой вызывает эмоциональную вовлечённость — ему хочется сопереживать, за него тревожиться или им восхищаться?",
        "chars_appearance_visualizable" to "Внешность главного героя описана достаточно, чтобы его можно было зрительно представить?",
        "chars_shown_not_told" to "Характер главного героя раскрывается через его поступки и реакции, а не через прямые авторские характеристики?",
        "chars_voice_distinctive" to "У главного героя узнаваемая, своя манера речи и поведения, отличающая его от других персонажей?",
        "chars_dialogue_alive" to "Реплики главного героя звучат как живая речь, а не как сухой обмен информацией?",
        "chars_sensory_concrete" to "Главный герой подан осязаемо — через детали, жесты и ощущения, а не только общими словами?",
        // Язык
        "lang_sentence_length_varies" to "Длина предложений в тексте варьируется — присутствуют и короткие (≤8 слов), и длинные (≥15 слов) предложения?",
        "lang_sentence_structure_varied" to "Структура предложений разнообразна — значительная доля предложений использует сложные конструкции (с союзами или обособленными оборотами)?",
        "lang_no_tautology" to "Текст практически свободен от тавтологий (повтор одного корня в соседних словах) и плеоназмов (избыточные сочетания типа «свободная вакансия», «упасть вниз»)?",
        "lang_reads_first_time" to "Предложения в тексте понятны с первого прочтения — фраз, требующих перечитывания, практически нет?",
        "lang_no_clumsy_phrases" to "Текст читается естественно — фраз с неудачным порядком слов или неестественным построением практически нет?",
        "lang_imagery_not_cliche" to "Типовые жанровые клише-образы («глаза как звёзды», «сердце разбилось на куски») встречаются в тексте редко?",
        "lang_register_fits_genre" to "Стиль речи в тексте подходит художественной прозе (преобладающий регистр не канцелярский)?",
        "lang_register_switches_intentionally" to "Стиль речи осознанно переключается между сценами разных типов (например, между описанием и диалогом)?",
        "lang_no_info_dump" to "В диалогах текста реплики-инфодампы — длинные пояснения, единственная цель которых сообщить читателю информацию для понимания сюжета (биографии, прошлые события, устройство мира или ситуации, профессиональные сведения), а не отреагировать на собеседника — встречаются редко?",
        "lang_has_subtext" to "В тексте регулярно встречаются реплики или действия, где явно подразумевается не то, что сказано или сделано напрямую?",
        "lang_distinct_voice" to "У прозы узнаваемый авторский голос — интонация и манера, по которым автора можно отличить от типовой жанровой прозы?",
        "lang_atmosphere_works" to "Текст создаёт устойчивое настроение или атмосферу через сочетание деталей, ритма и выбора слов?",
        "lang_dialogue_alive" to "Диалоги в тексте звучат как живая речь — разные персонажи говорят по-разному, а не одним голосом автора?",
        "lang_humor_works" to "В тексте есть удачные шутки, ироничные наблюдения или игра слов, которые реально срабатывают?",
        "lang_emotional_range" to "Текст показывает разнообразие эмоциональных регистров — переходы между, например, иронией и серьёзностью, грустью и лёгкостью?",
        // Первое впечатление
        "plot_hook_first_part" to "В первой части книги есть событие или ситуация, которая оставляет у читателя нерешённый вопрос?",
        "plot_orientation_clear" to "В первой части книги названы главный герой, место действия и время действия?",
        "plot_confusion_creates_intrigue" to "В книге есть моменты, которые сначала непонятны читателю, но потом получают объяснение в одной из последующих глав?",
        "plot_balance_fits_genre" to "Соотношение описаний, действия и диалогов в книге подходит к указанному жанру?",
        "plot_ending_fits_genre" to "Концовка книги отвечает ожиданиям от указанного жанра (для романа — соединение героев, для детектива — раскрытие преступления, для трагедии — катарсис)?",
        "plot_climax_earned" to "В кульминации герой достигает результата через действие с реальной ценой для него — а не как награду за ранее накопленные преимущества, удачное стечение обстоятельств или помощь со стороны?",
        "plot_costly_choices" to "Хотя бы одно решение героя оборачивается последствием, которое для него самого нежелательно и сохраняется до конца книги, — он страдает от него или сожалеет, а не получает взамен что-то большее?",
        "plot_theme_present" to "В книге прослеживается сквозная тема — утверждение о людях, мире или жизни, выходящее за рамки самого сюжета (например, «цена выбора», «одиночество», «принятие потери»), которое события книги последовательно иллюстрируют?",
        "plot_relationships_evolve" to "Хотя бы одни отношения между двумя названными персонажами качественно меняются по ходу книги — состояние в начале (доверие, вражда, дистанция, любовь, безразличие) к концу становится принципиально другим, и этот переход показан через события, а не объявлен в одной фразе?",
        "plot_reader_learns" to "К концу книги читателю становится понятно о мире, ситуации или людях нечто, что не было ясно в первой трети — то есть это новое понимание, а не просто новое событие?",
    ),
    aiCategoryStats = { yes, applicable, numeric ->
        val score = numeric?.let { " · ${(it * 10).toInt() / 10.0}/10" } ?: ""
        "$yes из $applicable «да»$score"
    },
    aiUnlock = { a1: Int -> "Получить глубокий разбор · $a1" },
    aiUnlockFree = "Получить глубокий разбор бесплатно",
    aiUnlockFreeAfterSignIn = "Войти — получить разбор бесплатно",
    aiSidebarRun = { a1: Int -> "Запустить · $a1" },
    aiSidebarSignIn = "Войти",
    aiFreeShortBadge = { a1: Int -> "Бесплатно (осталось ${a1} из 5)" },
    aiFreeShortBadgeAnon = "Бесплатно после входа",
    aiFreeShortHint = { a1: Int -> "Текст короткий — бесплатно. Сегодня осталось ${a1} из 5 запусков" },
    aiFreeShortHintAnon = "Текст короткий — после входа доступно 5 бесплатных запусков в день",
    aiFreeShortQuotaAnon = { chars ->
        "Тексты до $chars символов — 5 бесплатных запусков в день после входа"
    },
    aiFreeShortQuotaRemaining = { remaining, chars ->
        "Бесплатно — осталось $remaining из 5 запусков на коротких текстах (до $chars символов) сегодня"
    },
    aiFreeShortQuotaExhausted = { chars ->
        "Сегодняшние 5 бесплатных запусков на коротких текстах (до $chars символов) использованы"
    },
    analysisFailed = "Ошибка анализа",
    analyzing = { a1: String -> "Анализ ${a1}..." },
    appName = "Writers Lab",
    arcPrefix = "Арка: ",
    change = "Заменить",
    charactersLabel = "Героев",
    charsLabel = "Символов",
    close = "Закрыть",
    credits = "кредиты",
    detailedMetrics = "Детальные метрики",
    blockStatic = "Статический анализ",
    blockManuscript = "Редактирование",
    blockAi = "Глубокий анализ",
    blockPromo = "Промо-материалы",
    blockStaticSub = "Форма текста по статистике: ритм фразы, диалоги, длина предложений, богатство лексики — без вчитывания в смысл.",
    blockManuscriptSub = "Стилистические нарушения, подсвеченные прямо в тексте рукописи.",
    blockAiSub = "Разбор всей книги целиком: сюжет, персонажи, диалоги, проблемные сцены, неразрешённые линии.",
    blockPromoSub = "Материалы для продажи книги: аннотация, обложки, видео-тизер.",
    detailedMetricsExplain = "Здесь не нейросеть, а строгая лингво-статистика: алгоритм измеряет форму текста — ритм фразы, плотность диалогов, длину предложений, богатство лексики, — не вчитываясь в то, о чём он.\n\nЦелевые значения по каждой метрике — не литературный канон и не выбор критиков. Это среднее по книгам, которые лучше всего заходят массовому читателю на маркетплейсах: статистика того, какая форма текста чаще получает высокие читательские оценки.",
    blockKindStatic = "Статистика текста",
    blockKindAi = "Глубокий анализ",
    helpQualityTitle = "Общая оценка качества",
    helpQualityBody = "Сводный балл текста от 0 до 10 — насколько форма книги похожа на то, что хорошо читается массовой аудиторией.\n\nСчитается из десятков статистических метрик (ритм фразы, плотность диалогов, лексика, ясность и т. д.). Целевые значения берутся из книг, которые чаще всего получают высокие оценки читателей на маркетплейсах.\n\nЗдесь нет нейросети — это формальный анализ текста, без понимания сюжета. Рядом с баллом — объём, время чтения, повествование от 1-го/3-го лица и число героев.\n\nОценка рассчитана на цельное произведение любого объёма. Сборники рассказов и книги из нескольких независимых повестей усредняют метрики и дают смешанный результат.",
    helpHighlightsTitle = "Сильные и слабые места",
    helpHighlightsBody = "Две метрики, которые сильнее всего тянут общую оценку вверх, и две, которые тянут её вниз.\n\nЭто короткая выжимка из блока с детальными метриками — чтобы сразу видеть, что в тексте работает, а что портит впечатление, не разворачивая весь список.",
    helpAiScoreTitle = "Оценка глубокого разбора",
    helpAiScoreBody = "Итог глубокого анализа: общий балл от 0 до 10 и разбивка по ключевым составляющим — сюжет, персонажи, язык.\n\nКаждая категория получается ответом «да/нет» по нескольким десяткам критериев качества (внятная завязка, мотивации героев, ясность фраз и т. д.). Балл 10 ставится, если выполнено хотя бы 85% критериев — небольшой запас на то, что идеала не существует.",
    helpBookProfileTitle = "Профиль книги",
    helpBookProfileBody = "Атмосфера и общее настроение книги: преобладающее настроение текста, доли восьми базовых эмоций (радость, грусть, страх, гнев и т. д.) и автоматически подобранные жанровые теги.\n\nВсё считается по самому тексту: какие слова и в какой пропорции встречаются. Это не оценка качества, а характеристика — чтобы быстро понять, какого рода эта книга.",
    helpPromoSettingsTitle = "Название и автор",
    helpPromoSettingsBody = "Поля, которые используют генераторы обложки и видео-тизера. Заполняйте здесь один раз — оба генератора возьмут эти значения, печатать их повторно не нужно.",
    helpMetricsTitle = "Детальные метрики",
    helpMetricsBody = "Подробная разбивка по тем же статистическим показателям, из которых складывается общая оценка качества: ритм, диалоги, лексика, ясность, образность и т. д.\n\nЗелёная подсветка — метрика тянет оценку вверх. Красная — тянет вниз. У каждой метрики есть подсказка с целевыми значениями для текста, который попадает в массовый вкус.\n\nЭто формальный анализ, без понимания смысла: алгоритм читает форму, а не содержание.",
    helpPromoMaterialsTitle = "Промо-материалы",
    helpPromoMaterialsBody = "Готовые материалы для публикации книги: короткая аннотация, варианты обложки и видео-тизер.\n\nВсё генерируется с опорой на результат анализа: аннотация цепляет за сильные стороны книги, обложка и тизер подбирают визуальную манеру под настроение и жанр.\n\nАннотация и обложка появляются за десятки секунд, видео-тизер — за пару минут (это два шага: подбор кадра и его оживление).",
    helpAiInsightsTitle = "Глубокий разбор: отчёт",
    helpAiInsightsBody = "Полный текст разбора книги после прочтения её целиком. Внутри несколько вкладок:\n\n• Сюжет — устройство, ритм, конфликты, ставки, причинно-следственная связь.\n• Персонажи — мотивации, развитие, узнаваемость голосов.\n• Язык — ясность, образность, регистр, ритм фраз.\n• Рекомендации — что усилить в первую очередь.\n• Отзыв — оценка глазами читателя.\n• Незавершённые линии — то, что начато и нигде не закрыто.\n\nВ конце отчёта — таблица критериев, по которым выставлены оценки.",
    eulaPrefix = "Я согласен с",
    eulaLink = "пользовательским соглашением",
    privacyLink = "Политика конфиденциальности",
    metaTitle = "Writers Lab — анализ текста и AI-обзор книги",
    metaDescription = "Загрузите рукопись или книгу — Writers Lab разбирает стиль, темп, диалоги, персонажей и подсветит сильные и слабые места. AI-отчёт по запросу.",
    metaLocale = "ru_RU",
    balanceLabel = "Баланс",
    packsHeading = "Пополнить баланс",
    packStartName = "Старт",
    packMediumName = "Пачка",
    packLargeName = "Большая пачка",
    packPerBook = "за книгу",
    packDiscount = { pct -> "−$pct %" },
    packCreditsCount = { n -> when {
        n % 10 == 1 && n % 100 != 11 -> "$n кредит"
        n % 10 in 2..4 && n % 100 !in 12..14 -> "$n кредита"
        else -> "$n кредитов"
    } },
    packCheckoutStub = "Международная оплата ещё не подключена — напишите в поддержку",
    paymentSuccess = { n -> "Оплата прошла, начислено $n кредитов" },
    paymentCanceled = "Оплата отменена",
    checkoutRedirecting = "Переходим к оплате…",
    paymentWaitingBanner = "Ждём подтверждения оплаты. Если вы уже оплатили, кредиты появятся сами.",
    paymentResume = "Вернуться к оплате",
    paymentError = "Не удалось перейти к оплате. Попробуйте ещё раз позже",
    regionRussia = "Россия",
    regionInternational = "Остальной мир",
    weakMetricsHint = "Красным выделены характеристики, которые сильнее всего снижают итоговую оценку — стоит обратить на них внимание в первую очередь.",
    supportContact = "Связаться с поддержкой",
    supportEmailSubject = "Вопрос по Writers Lab",
    supportEmailBody = "Здравствуйте!\n\n",
    emotionAnger = "гнев",
    emotionAnticipation = "предвкушение",
    emotionDisgust = "отвращение",
    emotionFear = "страх",
    emotionJoy = "радость",
    emotionSadness = "грусть",
    emotionSurprise = "удивление",
    emotionTrust = "доверие",
    footerHint = "Часть what2read — сервисов о книгах",
    footerPowered = "© what2read",
    heroesMany = "много",
    heroesNone = "—",
    heroesOne = "один",
    heroesSeveral = "несколько",
    heroesVeryMany = "очень много",
    keyStrengths = "Сильные стороны",
    keyWeaknesses = "Слабые стороны",
    weaknesses = "Недостатки",
    promoSettingsLabel = "Для промо-материалов",
    replaceBook = "Заменить книгу",
    unresolvedEmptyTitle = "Всё сведено",
    unresolvedEmptyHint = "Сюжетные нити закрыты, заявленные мотивы доведены, ружья выстрелили. В тексте не нашлось оборванных линий — редкая удача, в большинстве рукописей что-нибудь да остаётся болтаться.",
    weakSpots = "Слабые места",
    readingTimeLabel = "Чтение",
    hoursShort = "ч",
    minutesShort = "мин",
    landingExampleAnnotationHook = "Английский джентльмен ставит половину состояния на то, что объедет земной шар за восемьдесят дней.",
    landingExampleAnnotationLabel = "Аннотация",
    landingExampleAnnotationText = "Лондонский джентльмен Филеас Фогг — человек настолько точный, что соседи сверяют по нему часы. Он живёт по расписанию, играет в карты в одном и том же клубе и не даёт слугам права на ошибку. Но однажды вечером он ставит на кон всё своё состояние — двадцать тысяч фунтов — и объявляет, что обернётся вокруг земного шара за восемьдесят дней. За ним немедленно устремляется погоня — тихая, методичная, неотступная. Впереди — Индия с её непроходимыми джунглями и чужими законами, Япония, американские прерии с их бизонами и племенами, штормовая Атлантика. Каждая задержка стоит часов, каждый час стоит денег, каждая ошибка может стоить всего.",
    landingExampleReviewLabel = "Рецензия",
    landingExampleReviewText = "Книга, основанная на путешествии загадочного джентльмена Филеаса Фогга, сочетает элементы приключений, интриги и культурных деталей, создавая динамичный сюжет, который увлекает читателя. Центральной метафорой становится ставка Фогга — объехать Землю за 80 дней, — что становится не только вызовом времени, но и метафорой борьбы с препятствиями, включая полицейское преследование, культурные конфликты и личные испытания. Главной сильной стороной произведения является его способность создавать напряжение через последовательность препятствий, каждое из которых раскрывает характеры персонажей и их мотивации.",
    landingHeadline = "От рукописи до готовой книги",
    landingSubheadline = "Помощник для работы над художественным текстом. Помогаем автору на каждом этапе — от разбора рукописи до обложки — и даём спокойный взгляд со стороны на вашу прозу.",
    landingFeaturesTitle = "Всё, что нужно автору, — в одном месте",
    landingFeaturesTextTitle = "Разобраться с текстом",
    landingFeaturesTextItems = listOf(
        "Разбор как от рецензента и бета-ридера" to "сюжет, персонажи, язык, сильные и слабые стороны, конкретные рекомендации.",
        "Слабые места — прямо в тексте" to "штампы, канцелярит, длинноты, вялые глаголы. Видно, что и где переписать.",
        "Профиль текста" to "темп, ритм, диалоги, читаемость — и насколько устройство близко к тому, что любит широкая аудитория.",
    ),
    landingFeaturesPubTitle = "Подготовить к публикации (в т.ч. самиздат)",
    landingFeaturesPubItems = listOf(
        "Аннотация" to "несколько вариантов, чтобы зацепить читателя.",
        "Обложка" to "готовая обложка под вашу книгу.",
        "Видео-тизер" to "короткий ролик по сценам книги — для соцсетей.",
    ),
    manuscriptTitle = "Текст рукописи",
    manuscriptHint = "Предпросмотр: так будет выглядеть текст рукописи. Подсветка найденных стилистических проблем появится здесь.",
    hlGroupCliche = "Штампы",
    hlGroupFilter = "Фильтрующие конструкции",
    hlGroupBureaucratese = "Канцелярит",
    hlGroupFiller = "Слова-паразиты",
    hlGroupBegan = "Непрямые действия",
    hlGroupTautology = "Плеоназмы",
    hlGroupWeakSpeech = "Наречия при глаголах речи",
    hlGroupAdjStack = "Нагромождение прилагательных",
    hlGroupAuthorStance = "Авторские вторжения",
    hlGroupIntensifier = "Усилители",
    hlGroupWeakVerb = "Слабые глаголы",
    hlGroupPassive = "Пассив",
    hlHintCliche = "заезженный образ — читатель скользит мимо, картинка не возникает. Как исправить: заменить свежей конкретной деталью или убрать — «повисла гробовая тишина» → «никто не решался звякнуть ложкой».",
    hlHintFilter = "фильтрует событие через восприятие героя («увидел, что…») и отдаляет читателя. Как исправить: показать напрямую — «он услышал, как хлопнула дверь» → «дверь хлопнула».",
    hlHintFiller = "слово без смысловой нагрузки. Как исправить: вычеркнуть — фраза почти всегда не пострадает: «он был, в общем, обычным парнем» → «он был обычным парнем».",
    hlHintBureaucratese = "казённый оборот вместо живого действия. Как исправить: заменить на простой глагол («осуществлять проверку» → «проверять»).",
    hlHintBegan = "«начал/стал делать» вместо прямого действия. Как исправить: убрать «начал/стал» — «он начал спускаться по лестнице» → «он спустился по лестнице».",
    hlHintTautology = "плеоназм — лишнее слово, значение которого уже есть в соседнем. Как исправить: убрать избыточное — «кивнул головой» → «кивнул», «самый лучший» → «лучший», «спустился вниз» → «спустился».",
    hlHintWeakSpeech = "наречие подпирает слабый глагол речи. Как исправить: передать интонацию действием или сильным глаголом — «сказал резко» → «отрезал».",
    hlHintAdjStack = "три и более определения подряд размывают образ. Как исправить: оставить одно-два самых точных — «высокий, худой, бледный незнакомец» → «худой бледный незнакомец».",
    hlHintAuthorStance = "прямая оценка или обращение к читателю. Как исправить: дать читателю сделать вывод самому — «разумеется, он был подлецом» → «он забрал деньги и не оглянулся».",
    hlHintIntensifier = "усиливает слабое слово вместо точного. Как исправить: подобрать сильное слово («очень большой» → «огромный»).",
    hlHintWeakVerb = "глагол состояния, а не действия — быть, находиться, стоять, сидеть, лежать: говорят, что кто-то просто есть или где-то расположен, но не показывают, что он делает, поэтому статичны. Как исправить: где уместно, заменить глаголом действия — «стоял у окна» → «застыл у окна», «был рад» → «просиял».",
    hlHintPassive = "страдательный залог: действие без деятеля, слабее и безличнее прямого. Как исправить: сделать залог активным — «дверь была открыта ветром» → «ветер распахнул дверь», «было решено» → «мы решили».",
    hlPrevIssue = "Предыдущее",
    hlNextIssue = "Следующее",
    hlModeStatic = "Статика",
    hlAiIntro = "Smart поиск стилистических нарушений",
    hlAiLoading = "Анализируем первые 30 000 символов…",
    hlAiError = "Не удалось проанализировать. Попробуйте ещё раз.",
    hlAiEmpty = "Нарушений не найдено.",
    hlAiFullLoading = "Разбираем всю рукопись — это может занять несколько минут…",
    hlAiBatchNote = { at -> "Стилистический анализ всей рукописи запущен в $at. Это долгая проверка: от нескольких минут до часа. Страницу можно закрыть — результат сохранится." },
    hlAiPreview = { free -> if (free != null && free > 0) "Первые 30k символов — бесплатно" else "Первые 30k символов — 1" },
    hlAiFull = { cost -> "Вся рукопись — $cost" },
    hlAiSignInToRun = "Для запуска нужно войти в аккаунт",
    hlAiFullRate = { cost -> "Полный разбор — $cost" },
    hlAiFullRateUnit = "за каждые 100k символов",
    hlScrollHintMouse = "Колесо прокручивает страницу · кликните по тексту, чтобы листать его",
    hlScrollHintTouch = "Листайте текст двумя пальцами",
    manuscriptLoading = "Загружаем текст…",
    manuscriptUnavailable = "Не удалось загрузить текст рукописи.",
    msEditLockedHint = "Правка текста доступна после первой покупки кредитов.",
    msSave = "Сохранить",
    msSaving = "Сохраняем…",
    msCancelEdit = "Отменить",
    msCancelConfirm = "Отменить правки?",
    msEditedCount = { n -> "Изменено абзацев: $n" },
    msSaved = { dropped -> if (dropped > 0) "Сохранено. Убрано smart-замечаний: $dropped." else "Сохранено." },
    msSavedReloadPage = "Сохранено, но текст на экране не обновился — обновите страницу, чтобы править дальше.",
    msSaveTextChanged = "Текст этой книги изменили в другой вкладке. Обновите страницу — ваши правки останутся в черновике.",
    msSaveScanRunning = "Идёт smart-проверка этой книги. Сохранить можно, когда она закончится, — правки не пропадут.",
    msSaveBusy = "Книга сейчас занята. Попробуйте сохранить через несколько секунд.",
    msSaveTooShort = { words -> "В тексте должно остаться не меньше 500 слов, сейчас $words." },
    msSaveFailed = "Не удалось сохранить. Попробуйте ещё раз — правки не пропали.",
    msEditedAt = { date -> "Текст изменён $date" },
    msDownloadTxt = "Скачать",
    msUncheckedNote = "Абзацы с фиолетовой полосой изменены после smart-проверки — замечания в них не перепроверены. Перепроверить их можно кнопкой «Проверить правки».",
    msDraftFound = "Есть несохранённые правки этой книги.",
    msDraftFoundStale = "Есть несохранённые правки этой книги, сделанные до её последнего сохранения. Если их восстановить, они заменят текущий текст.",
    msDraftRestore = "Восстановить",
    msDraftDiscard = "Удалить",
    msDone = "Готово",
    msRecheck = "Проверить правки",
    msRechecking = "Перепроверяем…",
    msRecheckFree = "бесплатно",
    msRecheckFreeSlot = "бесплатная проверка",
    msRecheckNeedsScan = "нужна smart-проверка",
    msRecheckNeedsScanNote = "Перепроверка работает по результатам smart-проверки. Запустите её под текстом — потом правки можно будет перепроверять по отдельности.",
    msRecheckNoChanges = "нет изменений",
    msRecheckNoChangesNote = "Изменённых мест пока нет. Поправьте текст и сохраните — перепроверим только изменённое.",
    msRecheckPriceLoading = "Считаем цену перепроверки — нажмите ещё раз через пару секунд.",
    msRechecked = { removed, added -> "Правки перепроверены: убрано замечаний — $removed, новых — $added." },
    msRecheckPriceChanged = "Цена перепроверки изменилась — она на кнопке. Нажмите ещё раз, если согласны.",
    msRecheckFailed = "Не удалось перепроверить. Если кредиты списались, они вернутся.",
    msRecheckRunning = "Перепроверяем изменённые места — от полуминуты до нескольких минут.",
    msLockTitle = "Правка прямо в тексте",
    msLockFix = "исправляйте подсвеченное здесь же",
    msLockRecheck = "перепроверяйте только изменённое",
    msLockDownload = "скачивайте исправленный текст",
    msLockPrice = { price -> "Открывается после первой покупки кредитов — от $price" },
    msLockChoosePack = "Выбрать пакет",
    msLockSignIn = "Войти",
    msLockLater = "Не сейчас",
    aiTextChanged = { date -> "Анализ сделан до правок текста" + (date?.let { " ($it)" } ?: "") + ". Перезапустите его, чтобы учесть правки." },
    landingFaqTitle = "Частые вопросы",
    landingFaq = listOf(
        "Не утечёт ли мой текст?" to """
            Нет. Более того — нам самим это невыгодно. Мы зарабатываем на помощи авторам, а не на их рукописях, а утечка чужого текста означала бы конец бизнеса: писательское сообщество тесное, и репутацию в нём не восстановить.

            Что мы гарантируем конкретно:

            - ваш текст не используется для обучения нейросетей;
            - авторские права полностью остаются за вами;
            - мы не передаём рукописи третьим лицам;
            - вы можете удалить рукопись в любой момент — достаточно написать в поддержку;
            - доступ команды к текстам ограничен и покрыт NDA.

            Всё это закреплено юридически — в пользовательском соглашении.
        """.trimIndent(),
        "Зачем сервис, если можно просто закинуть текст в ChatGPT?" to """
            - **Объём.** Мы работаем с текстами любой длины, и размер книги не влияет на качество разбора.
            - **Стабильность.** Обычный чат-бот при повторном запуске с тем же запросом каждый раз выдаёт разный ответ — у нас результат воспроизводим.
            - **Объективность.** Ответ любой нейросети определяется запросом, и, работая самостоятельно, вы вольно или невольно подгоняете его под желаемый вывод. Мы одинаково оцениваем все тексты.
            - **Методика.** Это не запрос «представь, что ты критик». Рецензия строится на десятках формальных вопросов о нюансах текста, составленных по множеству литературоведческих работ.
        """.trimIndent(),
        "Разве машина способна понять всю глубину литературы?" to """
            Вы правы: машина не заменит живого рецензента — и мы не ставим такой цели. Мы даём автору инструмент, чтобы быстро и без нервов получить максимально объективную обратную связь, доработать рукопись — и только потом показывать её критикам и читателям.

            Все мы знаем, как неприятно получать нелестные отзывы от людей. А необъективная похвала порой ещё вреднее. Ответ сервиса всегда конструктивен, и о недочётах мы стараемся говорить мягко — чтобы поберечь ваши нервы, но дать полезный отзыв.
        """.trimIndent(),
        "Может ли сервис заменить редактора или бета-ридеров?" to """
            Нет — и не ставит такой цели. Текстовые редакторы давно умеют подчёркивать ошибки, но это помогает редактору, а не заменяет его. Так и наш сервис: помогает автору подготовить рукопись — увидеть слабые места и доработать текст, прежде чем показывать его живым читателям, редактору или критику. Живого человека он не заменяет.
        """.trimIndent(),
        "Сервис оценил мою книгу низко. Значит, она плохая?" to """
            Нет. Сервис не ставит оценок книге и не судит о её качестве — он показывает особенности текста: темп, динамику, структуру, ритм и другие характеристики. Низкое значение по какой-то из них — не приговор книге, а лишь повод присмотреться к конкретной стороне текста. Что с этим делать — и делать ли вообще — решаете только вы.
        """.trimIndent(),
        "А если мой роман сложный, философский или экспериментальный?" to """
            Сервис работает с любой прозой — сложной, философской, экспериментальной. Он не оценивает художественную ценность и не решает, «хорошая» книга или «плохая». Он показывает, как устроен текст: его темп, структуру, динамику — а это полезно для любого романа, даже самого нестандартного. Такие характеристики помогают увидеть, где текст ведёт читателя за собой, а где рискует его потерять. Учитывать это или сознательно оставить как есть — решать вам.
        """.trimIndent(),
        "Вы будете переписывать мою книгу?" to """
            Нет.

            Мы не пишем книгу вместо автора и не исправляем стиль «под шаблон». Мы показываем, как устроен текст и как он воспринимается, чтобы автор сам принимал творческие решения.
        """.trimIndent(),
        "Аннотация получится шаблонной?" to """
            Нет.

            Мы создаём несколько вариантов, опираясь на содержание и особенности книги. Задача аннотации — не пересказать сюжет, а заинтересовать будущего читателя.
        """.trimIndent(),
        "Зачем вообще анализировать ритм и темп?" to """
            То, как читается книга, зависит не только от сюжета.

            Ритм, длина предложений, количество диалогов и эмоциональная насыщенность влияют на восприятие текста. Анализ помогает увидеть эти особенности со стороны — то, что сложно заметить, когда долго работаешь над рукописью.
        """.trimIndent(),
    ),
    loadingMessages = listOf(
        "Будим Музу...",
        "Завариваем чай...",
        "Ищем закладку...",
        "Считаем многоточия...",
        "Проверяем запятые...",
        "Перелистываем страницы...",
        "Перечитываем первую страницу...",
        "Выясняем, кто кому кем приходится...",
        "Восстанавливаем хронологию...",
        "Ищем, где всё пошло не так...",
        "Уточняем мотивацию персонажей...",
        "Определяем, кто злодей...",
        "Считаем смерти персонажей...",
        "Устанавливаем, кто в кого влюблён...",
        "Взвешиваем метафоры...",
        "Сортируем эпитеты...",
        "Пересчитываем авторские тире...",
        "Измеряем длину отступлений...",
        "Считаем слово «вдруг»...",
        "Считаем наречия...",
        "Анализируем лишний абзац...",
        "Прогнозируем, где читатель бросит книгу...",
        "Оцениваем шансы на хэппи-энд...",
        "Прикидываем качество экранизации...",
        "Считаем страдания главного героя...",
        "Выясняем, стоило ли оно того...",
        "Ищем символизм в погоде...",
        "Ищем любимое слово автора...",
        "Считаем долю диалогов...",
        "Проверяем концовки глав...",
        "Считаем флэшбэки...",
        "Оцениваем любовную линию...",
        "Ищем чеховское ружьё...",
        "Проверяем, выстрелило ли оно...",
        "Определяем темп повествования...",
        "Замеряем длину предложений...",
        "Считаем однофамильцев...",
        "Ищем plot hole...",
        "Делаем вид, что не нашли...",
        "Собираем описания еды...",
        "Оцениваем достоверность злодея...",
        "Ищем любимый цвет автора...",
        "Считаем случайные совпадения...",
        "Ищем скрытые отсылки...",
        "Оцениваем симпатичность героя...",
        "Ищем забытых персонажей...",
        "Выясняем смысл названия главы...",
        "Считаем экшен и рефлексию...",
        "Ищем момент разгадки...",
        "Считаем взгляды в окно...",
        "Оцениваем психологизм героя...",
        "Определяем настоящий жанр книги...",
        "Ищем, где автор устал...",
        "Ищем счастливого персонажа...",
        "Считаем упоминания луны...",
        "Восстанавливаем карту мира...",
        "Выясняем, чья это история...",
        "Проверяем соответствие названия...",
        "Ищем авторскую позицию...",
        "Анализируем динамику персонажей...",
        "Ищем обделённых персонажей...",
        "Убираем героя — смотрим, что осталось...",
        "Проверяем стороны света...",
        "Считаем многозначительные паузы...",
        "Определяем тон финала...",
        "Выясняем, почему такой конец...",
    ),
    metricArcVolatility = "Перепады",
    metricAuthorStance = "Авт.позиция",
    metricCefrRange = "Диапазон CEFR",
    metricCleanSyntax = "Чистый синтаксис",
    metricCoherence = "Связность",
    metricComplexity = "Сложность",
    metricConcreteness = "Конкретность",
    metricDialogue = "Диалоги",
    metricDirectPov = "Прямое повествование",
    metricDirectness = "Прямота",
    metricExpressiveness = "Экспрессия",
    metricFillers = "Чистота речи",
    metricLiveliness = "Живость",
    metricMorality = "Мораль",
    metricNoNominalisation = "Без номинализаций",
    metricNoRepetition = "Без повторов",
    metricOriginality = "Оригинальность",
    metricPace = "Темп",
    metricPathos = "Пафос",
    metricPhrasalVerbs = "Фразовые глаголы",
    metricPrecision = "Точность",
    metricRareVocabulary = "Редкая лексика",
    metricRegisterShift = "Смена регистра",
    metricRhythm = "Ритм",
    metricSensory = "Сенсорика",
    metricStageDirections = "Жестикуляция",
    metricVerbStrength = "Сила глаголов",
    metricVividness = "Яркость",
    metricVocabulary = "Лексика",
    metricVocabularyAge = "Возраст лексики",
    metricVoices = "Голоса",
    moodBright = "светлое",
    moodDark = "тёмное",
    moodHeavy = "тяжёлое",
    moodLabel = "Настроение книги",
    moodNeutral = "нейтральное",
    moodRatherBright = "скорее светлое",
    moodRatherDark = "скорее тёмное",
    povFirst = "1-е лицо",
    povLabel = "Лицо повествования",
    povMixed = "смешанное",
    povThird = "3-е лицо",
    povUnknown = "—",
    previousBooks = "Ранее проанализированные",
    historyEmptyTitle = "Здесь будут ваши книги",
    historyEmptyHint = "Загрузите первую — анализ сохранится в истории",
    badgeDeep = "Рецензия",
    badgeSmart = "Проверка стиля",
    badgeDeepTip = "Глубокий анализ книги уже сделан",
    badgeSmartTip = "Стилистические проблемы в тексте уже подсвечены",
    retryButton = "Попробовать снова",
    menuAria = "Меню",
    qualityHint = "Предсказывает, как читатели обычно оценивают тексты с похожим стилем",
    qualityCaveat = "Оценка может быть неточной. Она опирается на современную художественную литературу, которая лучше всего заходит массовому читателю — поэтому для переводных текстов, для книг прошлых эпох и для нехудожественной прозы балл часто оказывается заниженным.",
    redeemApply = "Активировать",
    redeemCodeHint = "Введите код активации",
    redeemErrorFormat = "Неверный формат кода",
    redeemErrorNetwork = "Не удалось связаться с сервером",
    redeemErrorUsed = "Код недействителен или уже использован",
    redeemSuccess = { a1: Int -> "+${a1} кредитов зачислено" },
    relationships = "Отношения",
    sectionNarrative = "Характер текста",
    sectionNarrativeHint = "Зависит от жанра и замысла автора",
    sectionProfile = "Профиль",
    sectionProfileHint = "Описательные характеристики, зависят от жанра",
    sectionStyle = "Формальная чистота",
    sectionStyleHint = "Соответствие рекомендациям по стилю",
    sectionStyleHintUnreliable = "Соответствие рекомендациям по стилю",
    shortTextWarningModerate = "Статический анализ ниже работает по статистическим метрикам и нуждается в тексте от 30 000 слов (около одной книги среднего размера) для надёжных оценок стиля. На вашем тексте они могут быть неточными. Глубокий анализ работает корректно при любой длине.",
    shortTextWarningSevere = "Статический анализ ниже требует минимум 5 000 слов для базовых метрик и от 30 000 для стилевых. На таком коротком тексте результаты могут быть близки к случайным. Глубокий анализ работает корректно на любой длине.",
    signIn = "Войти",
    signOut = "Выйти",
    storyAndCharacters = "Сюжет и персонажи",
    strengths = "Достоинства",
    tabPlot = "Сюжет",
    characterAssessment = "Оценка персонажей",
    plotStructure = "Структура",
    plotPacing = "Темп",
    plotConflict = "Конфликт",
    plotStakes = "Ставки",
    plotCausality = "Причинно-следственная связь",
    charConsistency = "Соответствие характеров и поступков",
    charDepth = "Глубина проработки",
    charMotivation = "Мотивация",
    charDistinctness = "Отличимость персонажей",
    charArc = "Развитие характеров",
    tabLanguage = "Язык",
    aiPreviewLanguageDesc = "Оценка качества языка прозы: синтаксис, словарь, ясность, образность, регистр. То, что неспособна различить чистая статистика: грамотная ли проза, не косноязычная ли, не клиширована ли — и где это видно по тексту.",
    aiPreviewLanguageSample = "Sample: «Синтаксис разнообразен — короткие нервные фразы в сцене погони сменяются длинными периодами в рефлексивных фрагментах. Лексика точна, но не пестрит: автор предпочитает рабочий словарь художественной прозы…»",
    languageSentenceCraft = "Синтаксис и ритм",
    languageVocabulary = "Лексика и словарь",
    languageClarity = "Ясность и читабельность",
    languageImagery = "Образы и метафоры",
    languageRegister = "Регистр и стиль",
    tabCharacters = "Персонажи",
    tabRecommendations = "Рекомендации",
    tabReview = "Рецензия",
    tabStrengths = "+/−",
    tabUnresolved = "Незавершённые",
    promoMaterialsTitle = "Промо-материалы",
    promoMaterialsHintReady = "Сгенерируйте материалы для презентации книги",
    promoMaterialsHintLocked = "Сначала запустите глубокий анализ",
    promoAnnotationTitle = "Аннотация",
    promoCoverTitle = "Обложка",
    promoCoverTitleLabel = "Название книги",
    promoCoverAuthorLabel = "Автор (необязательно)",
    promoCoverVariantPrefix = "Вариант",
    promoCoverGenerateAll = "Сгенерировать обложки",
    promoCoverRegenerateAll = "Сгенерировать всё заново",
    promoCoverRegenerateOne = "Перегенерировать этот",
    promoCoverDownloadOne = "Скачать",
    promoCoverDownloadAll = "Скачать все",
    promoCoverTitleRequired = "Введите название книги",
    promoCoverTextModeLabel = "Название на обложке",
    promoCoverTextModeOverlay = "Поверх картинки (вектор)",
    promoCoverTextModeBaked = "Часть картинки",
    promoVideoTitle = "Промо-ролик",
    promoGenerateButton = "Сгенерировать",
    promoRegenerateButton = "Сгенерировать заново",
    promoGeneratingLabel = "Генерируем…",
    promoTeaserPreviewButton = "Подобрать сцену",
    promoTeaserPickAnotherScene = "Попробовать другую сцену",
    promoTeaserRenderVideoButton = "Сделать видео",
    promoTeaserDownloadButton = "Скачать видео",
    promoTeaserLoadingPreview = "Подбираем сцену и рисуем кадр… (~30 сек)",
    promoTeaserLoadingVideo = "Делаем видео из кадра… (1-2 мин ожидания)",
    promoTeaserLoadingRegenerate = "Подбираем новую сцену… (~30 сек)",
    promoTeaserSceneLabel = "Сцена",
    promoTeaserErrorCopyright = "Не удалось анимировать сцену — сработал " +
        "фильтр авторских прав. Обычно это случается на известных " +
        "франшизах и узнаваемых персонажах. Попробуйте другую сцену " +
        "или измените название книги.",
    promoTeaserErrorPrivacyFace = "Видео-модель отклонила кадр с " +
        "распознаваемым лицом. Попробуйте пересоздать сцену (другой " +
        "персонаж или ракурс) или сгенерируйте в полном качестве — " +
        "там фильтр мягче.",
    promoAnnotationPlaceholderHeading = "Аннотация — витрина книги",
    promoAnnotationPlaceholderBody = "За пять секунд читатель решает: открыть или пройти " +
        "мимо. Автору этот текст даётся труднее всего — он слишком близко к собственной " +
        "истории, чтобы выбрать в ней самое цепляющее. Наш генератор опирается на " +
        "исследования по копирайтингу и нейромаркетингу: точный хук, ясные ставки и " +
        "недосказанность в финале — всё работает на то, чтобы книгу открыли.",
    promoAnnotationDownloadButton = "Скачать",
    priceTag = { n -> if (n == 0) " · бесплатно" else " · $n" },
    priceUnits = { n -> "$n кр" },
    promoTeaserStepsHeading = "Тизер делается в два шага:",
    promoTeaserStep1Title = "Подбор сцены и кадра",
    promoTeaserStep1Time = "~30 сек",
    promoTeaserStep1Cost = { freeQuota, unitCost ->
        "$freeQuota бесплатно на аккаунт, далее $unitCost кр"
    },
    freeQuotaAnnotationRemaining = { remaining, total ->
        "Бесплатно — осталось $remaining из $total бесплатных аннотаций"
    },
    freeQuotaAnnotationExhausted = { total ->
        "Бесплатные аннотации закончились ($total из $total использовано). " +
            "Следующая — за кредиты."
    },
    freeQuotaCoverRemaining = { remaining, total ->
        "Бесплатно — осталось $remaining из $total бесплатных сетов обложек"
    },
    freeQuotaCoverExhausted = { total ->
        "Бесплатные сеты обложек закончились ($total из $total использовано). " +
            "Следующая генерация — за кредиты."
    },
    freeQuotaTeaserRemaining = { remaining, total ->
        "Бесплатно — осталось $remaining из $total бесплатных подборов сцены"
    },
    freeQuotaTeaserExhausted = { total ->
        "Бесплатные подборы сцены закончились ($total из $total использовано). " +
            "Следующий подбор — за кредиты."
    },
    freeQuotaHighlightRemaining = { remaining, total ->
        "осталось $remaining из $total бесплатных проверок"
    },
    freeQuotaHighlightExhausted = { _ ->
        "бесплатные проверки использованы"
    },
    promoTeaserStep2Title = "Рендер видео",
    promoTeaserStep2Time = "~1–2 мин",
    promoTeaserStepsTotalLabel = "Итого за 5-сек ролик",
    promoHookVariantsLabel = "Заголовок:",
    promoStatusReady = "Готово к генерации",
    promoStatusLocked = "Доступно после глубокого анализа",
    tag19thCentury = "19 век",
    tagAcademy = "академия",
    tagAction = "боевик",
    tagAntiquity = "античность",
    tagApocalypse = "апокалипсис",
    tagAscension = "восхождение",
    tagCastlePalace = "замок/дворец",
    tagChosenOne = "избранный",
    tagComingOfAge = "взросление",
    tagCozy = "уютное",
    tagCyberpunk = "киберпанк",
    tagDark = "мрачное",
    tagDarkLord = "тёмный властелин",
    tagDemons = "демоны",
    tagDetective = "детектив",
    tagDragons = "драконы",
    tagDystopia = "антиутопия",
    tagElves = "эльфы",
    tagEnemiesToLovers = "враги к любви",
    tagFakeMarriage = "фиктивный брак",
    tagFantasy = "фэнтези",
    tagForbiddenLove = "запретная любовь",
    tagFuture = "будущее",
    tagHeist = "ограбление",
    tagInvestigation = "расследование",
    tagIronic = "ироничное",
    tagIsekai = "попаданцы",
    tagIsekaiFemale = "попаданка",
    tagLitrpg = "литрпг",
    tagLoneliness = "одиночество",
    tagLossGrief = "утрата/горе",
    tagMagic = "магия",
    tagMedieval = "средневековье",
    tagMercenary = "наёмник",
    tagNostalgic = "ностальгическое",
    tagPoliticsIntrigue = "политика/интриги",
    tagPostApocalypse = "постапокалипсис",
    tagPowerTyranny = "власть/тирания",
    tagPrison = "тюрьма",
    tagRedemption = "искупление",
    tagRevenge = "месть",
    tagRomance = "романтика",
    tagSchoolAcademy = "школа/академия",
    tagSciFi = "научная фантастика",
    tagSeaShip = "море/корабль",
    tagSecondChance = "второй шанс",
    tagSpace = "космос",
    tagSport = "спорт",
    tagSpy = "шпионский",
    tagSteampunk = "стимпанк",
    tagThriller = "триллер",
    tagTournament = "турнир",
    tagUssr = "СССР",
    tagVampires = "вампиры",
    tagWar = "война",
    tagWerewolves = "оборотни",
    tagWw2 = "ВОВ",
    tagZombies = "зомби",
    textQuality = "Качество текста",
    tipArcVolatility = "Сила эмоциональных перепадов по ходу книги. Низко — ровный тон, высоко — резкие смены между мрачным и светлым. Подбирается под замысел, не «лучше/хуже».",
    tipAuthorStance = "Маркеры авторского давления: «конечно», «очевидно», «разумеется». Низко — автор не давит на читателя, высоко — навязывает выводы. Чтобы поднять — убирай оценочные вставки от автора.",
    tipCefrRange = "Разброс лексики по уровням сложности (A1-C2 + редкие). Низко — текст держится в одном узком диапазоне, высоко — равномерно использует и лёгкие, и сложные слова.",
    tipCleanSyntax = "Среднее расстояние между связанными словами в предложении. Низко — фразы короткие и читаются легко, высоко — длинные ветвящиеся конструкции. Чтобы упростить — режь предложения короче.",
    tipCoherence = "Связность: насколько соседние предложения тянут общую тему. Низко — текст «прыгает», высоко — единая ткань. Чтобы поднять — повторяй ключевые слова и связки между предложениями.",
    tipComplexity = "Сложность для чтения: длина абзацев и предложений, пунктуация, доля диалогов. Низко — лёгкий текст, высоко — плотный и трудный. Подбирается под аудиторию, не «лучше/хуже».",
    tipConcreteness = "Конкретность слов: физические объекты vs абстракции. Низко — абстрактная «голова в облаках», высоко — осязаемые образы. Чтобы поднять — выбирай конкретные существительные вместо общих понятий.",
    tipDialogue = "Доля прямой речи. Низко — нарратив без диалогов, высоко — почти весь текст в репликах. Подбирается под жанр.",
    tipDirectPov = "Плотность глаголов восприятия с местоимением: «он увидел», «она почувствовала». Низко — прямое повествование, высоко — события отфильтрованы через героя. Низкое читается живее.",
    tipDirectness = "Прямота действий: «решил» вместо «принял решение», «пришёл» вместо «осуществил визит». Низко — много отглагольных конструкций, высоко — действия названы напрямую. Чтобы поднять — заменяй «делать X» на короткий глагол.",
    tipExpressiveness = "Эмоциональная пунктуация: восклицания, вопросы, многоточия. Низко — спокойный тон, высоко — много эмоциональных всплесков. Подбирается под жанр.",
    tipFillers = "Слова-паразиты: «ну», «вот», «как бы», «в общем». Низко — паразитов много, высоко — речь чистая. Чтобы поднять — пройдись поиском по этим словам и удали лишнее.",
    tipLiveliness = "Свобода от канцелярита: «является», «в связи с», «осуществить», «данный». Низко — много казённых оборотов, высоко — живая речь. Чтобы поднять — переписывай «в связи с тем что» → «потому что», «осуществить» → «сделать».",
    tipMorality = "Доля моральной лексики: совесть, справедливость, предательство, прощение. Низко — тема морали не звучит, высоко — этические дилеммы в центре книги. Подбирается под замысел.",
    tipNoNominalisation = "Плотность «zombie nouns» — существительных на -tion/-sion/-ment/-ity/-ness/-ism. Низко — глаголы доминируют, высоко — существительные душат действие. Чтобы поднять — переписывай «made a decision» → «decided».",
    tipNoRepetition = "Повторение одних и тех же слов в окне 50 слов. Низко — текст однообразный, высоко — лексически разнообразный. Чтобы поднять — заменяй повторы синонимами или местоимениями.",
    tipOriginality = "Свобода от штампов: «глаза горели огнём», «сердце замерло». Низко — много готовых клише, высоко — формулировки свежие. Чтобы поднять — переписывай заезженные обороты своими словами.",
    tipPace = "Темп повествования. Низко — размеренное описание, высоко — короткие абзацы, много диалогов и действия. Подбирается под жанр.",
    tipPathos = "Высокий регистр: «великий», «доблесть», «священный», «торжество». Низко — приземлённая лексика, высоко — пафосный тон. Подбирается под жанр (фэнтези/исторический ↔ лит-фикшн).",
    tipPhrasalVerbs = "Плотность фразовых глаголов: figure out, make up, look into. Низко — формальный регистр, высоко — разговорный. Подбирается под тон книги.",
    tipPrecision = "Скупость на усилители: «очень», «крайне», «абсолютно», «невероятно». Низко — текст подпёрт ими, высоко — точные формулировки без подпорок. Чтобы поднять — заменяй «очень большой» одним сильным словом («огромный»).",
    tipPrefix = "Совет: ",
    tipRareVocabulary = "Доля слов вне CEFR-словаря A1-C2: имена, термины, неологизмы. Низко — обычная лексика, высоко — много специальных слов. Зависит от жанра.",
    tipRegisterShift = "Разница уровня лексики между нарративом и репликами. Низко — оба слоя похожи, высоко — герои говорят заметно проще или сложнее автора. Высокое — намеренный контраст регистров.",
    tipRhythm = "Разнообразие длины предложений. Низко — все одной длины (монотонно), высоко — короткие чередуются с длинными. Чтобы поднять — варьируй ритм.",
    tipSensory = "Слова ощущений: звуки, запахи, прикосновения, вкусы. Низко — текст на одних мыслях и диалогах, высоко — задействованы все органы чувств. Чтобы поднять — добавляй конкретные сенсорные детали.",
    tipStageDirections = "Плотность мелких действий тела: «кивнул», «пожал плечами», «бросил взгляд». Низко — герои бестелесны, высоко — постоянно двигаются. Перебор читается механично.",
    tipVerbStrength = "Сила глаголов: «мчаться», «рухнуть» сильнее «быть», «являться», «находиться». Низко — много слабых форм, высоко — активные глаголы. Чтобы поднять — заменяй «был» на действие.",
    tipVividness = "Образность языка: метафоры, сенсорные детали, конкретные образы. Низко — сухое описание, высоко — живые картинки в воображении читателя. Чтобы поднять — добавляй конкретные образы вместо абстракций.",
    tipVocabulary = "Богатство словаря (индекс MTLD). Низко — слова повторяются, высоко — речь живая, синонимы активно используются. Чтобы поднять — заменяй повторы синонимами.",
    tipVocabularyAge = "Средний возраст усвоения слов в годах. Низко — детская/повседневная лексика, высоко — абстрактная или специальная. Зависит от целевой аудитории.",
    tipVoices = "Различимость речи разных персонажей. Низко — все говорят одинаково, высоко — у каждого свой голос. Чтобы поднять — давай каждому свой словарь, ритм, любимые словечки.",
    topUpDebug = "+10 кредитов (отладка)",
    topUpTitle = "Пополнение баланса",
    signupBonusTitle = "Войдите — и заберите бонус за регистрацию",
    signupBonusBody = { annotations, covers, checks ->
        "и бесплатные генерации: аннотация ×$annotations, обложки ×$covers, проверка текста ×$checks"
    },
    verificationBannerText = { email -> if (email.isNotEmpty()) "Подтвердите $email, чтобы использовать кредиты — ссылка уже отправлена на вашу почту." else "Подтвердите email, чтобы использовать кредиты — ссылка уже отправлена на вашу почту." },
    verificationRequired = "Сначала подтвердите email — проверьте почту",
    verificationResend = "Отправить повторно",
    verificationConfirm = "Уже подтвердил",
    verificationEmailSent = "Письмо отправлено — проверьте почту",
    verificationEmailError = "Не удалось отправить письмо, попробуйте позже",
    verificationCooldown = { s -> "Повторно можно через $s сек." },
    verificationCooldownButton = { s -> "Через $s с." },
    verificationNotYet = "Email ещё не подтверждён — проверьте почту",
    verificationAlreadyDone = "Email уже подтверждён",
    unsupportedLanguageMessage = "Не удалось определить язык. Возможно, текст в файле извлёкся как нечитаемая последовательность — посмотрите фрагмент ниже.",
    unsupportedLanguageSampleHeader = "Извлечённый текст:",
    uploadFormats = ".fb2, .epub, .txt, .html, .docx, .pdf",
    uploadPrivacy = "Текст не передаём третьим лицам, не используем для других целей и не претендуем на права на результаты.",
    uploadScope = "Подходит для отдельного произведения любого объёма. Сборники рассказов и книги из нескольких независимых повестей дадут смешанные результаты.",
    uploadTitle = "Загрузите рукопись",
    wherePrefix = "Где: ",
    words = "Слов",
    wordsAndChange = "слов / заменить",
)
